import * as yup from 'yup';
import parse from 'date-fns/parse';
import { allCountries } from '../data/countries';

// const passwordRules = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{5,}$/;
// min 5 characters, 1 upper case letter, 1 lower case letter, 1 numeric digit.

export const userSchema = yup.object().shape({
  username: yup
    .string()
    .min(5, 'Must be at least 5 characters long')
    .required('Required'),
  firstName: yup
    .string()
    .min(3, 'Must be at least 3 characters long')
    .required('Required'),
  lastName: yup
    .string()
    .min(3, 'Must be at least 3 characters long')
    .required('Required'),
  title: yup.string().lowercase(),
  email: yup.string().email('Please enter a valid email').required('Required'),
  gender: yup.string().lowercase().oneOf(['male', 'female', 'other']).defined(),
  dateOfBirth: yup
    .date()
    .min(new Date(1900, 0, 1), 'invalid')
    .max(new Date(), `Can't be future value!`)
    .required('Required')

    .transform(function (value, originalValue) {
      if (this.isType(value)) {
        return value;
      }
      const result = parse(originalValue, 'dd.MM.yyyy', new Date());
      return result;
    })
    .typeError('please enter a valid date'),
  // .min('1900-01-03', 'Date is too early')
  age: yup
    .number()
    .max(199, 'Too large number')
    .positive()
    .integer()
    .required('Required'),
  streetName: yup
    .string()
    .min(3, 'Must be at least 3 characters long')
    .required('Required'),
  streetNumber: yup.mixed().required('Required'),
  state: yup
    .string()
    .min(3, 'Must be at least 3 characters long')
    .required('Required'),
  country: yup
    .string()
    .min(3, 'Must be at least 3 characters long')
    .oneOf(allCountries, 'Must be a valid country')
    .required('Required'),
  city: yup
    .string()
    .min(3, 'Must be at least 3 characters long')
    .required('Required'),
  postcode: yup
    .string()
    .min(3, 'Must be at least 3 characters long')
    .required('Required'),

  createdOn: yup.date().default(() => new Date()),
});
